// import AssignmentReport from '../views/AssignmentReport';
// import NewAssignment from '../views/NewAssignment';
// import Assignments from '../views/Assignments';

const router = [
  // {
  //   path: '/reports',
  //   redirect: () => ('/reports/assignments'),
  // },
  // {
  //   name: 'assignments.assignments',
  //   path: '/reports/assignments',
  //   component: Assignments,
  //   meta: {
  //     requiresAuth: true,
  //     requiresTeacherRole: true,
  //   },
  // },
  // {
  //   name: 'assignments.newAssignment',
  //   path: '/new-assignment',
  //   component: NewAssignment,
  //   meta: {
  //     requiresAuth: true,
  //     requiresTeacherRole: true,
  //   },
  // },
  // {
  //   name: 'assignments.assignmentReport',
  //   path: '/reports/assignments/:assignment_id',
  //   component: AssignmentReport,
  //   meta: {
  //     requiresAuth: true,
  //     requiresTeacherRole: true,
  //   },
  // },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/assignments/router/index.js